import { ItemDataImageProps } from 'store/types'
import PostImagePlaceholder from 'molecules/post-items/image/PostImagePlaceholder'
import Image from 'atoms/Image'

function PostItemImage({ backgroundColor, file }: ItemDataImageProps) {
  return (
    <div
      className='w-full h-full overflow-hidden'
      style={{
        backgroundColor
      }}>
      <div className='flex items-center justify-center h-full'>
        {file ? <Image className='w-full h-full object-cover' src={file} /> : <PostImagePlaceholder />}
      </div>
    </div>
  )
}

export default PostItemImage
